/**
 * Inject Variables Drupal to vuejs
 */
const DrupalSettings = window?.drupalSettings?.sante_resultats_edito
  ? {
    apiBasePath: window?.drupalSettings?.sante_resultats_edito?.apiBasePath,
    what: window?.drupalSettings?.sante_resultats_edito.what,
    where: window?.drupalSettings?.sante_resultats_edito.where,
    titleH1: window?.drupalSettings?.sante_resultats_edito.page.title_result,
    titlePopinAnd: window?.drupalSettings?.sante_resultats_edito.page.ordering_and_title,
    contentPopinAnd: window?.drupalSettings?.sante_resultats_edito.page.ordering_and_text,
    titlePopinOr: window?.drupalSettings?.sante_resultats_edito.page.ordering_and_title,
    contentPopinOr: window?.drupalSettings?.sante_resultats_edito.page.ordering_or_text,
    qty: window?.drupalSettings?.sante_resultats_edito.qty,
    messageGeloc: window?.drupalSettings?.sante_resultats_edito.search_region_message,
    no_result: {
      title: window?.drupalSettings?.sante_resultats_edito.no_result.title,
      text: window?.drupalSettings?.sante_resultats_edito.no_result.texte,
      text_button: window?.drupalSettings?.sante_resultats_edito.no_result.text_button,
      url_button: window?.drupalSettings?.sante_resultats_edito.no_result.url_button,
      description: window?.drupalSettings?.sante_resultats_edito.no_result.description,
    },
  }
  : { apiBasePath: window.drupalSettings.path.baseUrl };

export default DrupalSettings;
